import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { DashboardFilters, DashboardFiltersSkeleton, } from "../../../components/dashboard/DashboardFilters";
export function MulheresFilters(_a) {
    var dynamicSubtab = _a.dynamicSubtab, filters = _a.filters, onChange = _a.onChange, onClear = _a.onClear;
    if (!dynamicSubtab) {
        return (_jsx(DashboardFiltersSkeleton, { count: 2, labels: ["Ano", "Território"] }));
    }
    var handleChange = function (key, value) {
        onChange(key, value);
    };
    return (_jsx(DashboardFilters, { endpoint: dynamicSubtab.filtersEndpoint, values: filters, testIdPrefix: "mulheres-filter", onChange: handleChange, onClear: onClear }));
}
